<template>
  <div style="padding:15px" class="containerTable">
    <vxe-toolbar id="toolbarId_ba2" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button v-if="branch.level <1" @click="funcAdd">新增</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"  
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="shipmentName" title="客户" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.shipmentName" placeholder="请输入客户名称" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="chargingType" title="计费类型" min-width="100" sortable />
        <template v-slot:header>
          <costTypeSelect ref="costType" @queryCostType="selectCostType" />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="price" title="单价" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.price" placeholder="请输入单价" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="chargingMode"
          title="计费方式"
          :formatter="formatterChargingMode"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.chargingMode" placeholder="请选择" clearable>
            <el-option value label="请选择" />
            <el-option value="1" label="吨" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="startDate"
          title="有效期"
          min-width="350"
          :formatter="termOfValidityFormatter"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.validityDate"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column v-if="branch.level <1" title="操作" fixed="right" width="130">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />

    <vxe-modal v-model="modelAddFlag" title="新增仓储计费协议" width="500" height="570" resize>
      <compAdd ref="addRef" @fatherAddMethod="fatherAdd" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal v-model="modelEditFlag" title="编辑仓储计费协议" width="500" height="570" resize>
      <compEdit ref="editRef" @fatherEditMethod="fatherEdit" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
  </div>
</template>
<script>
import compAdd from "./components/chargingTypeAdd.vue";
import compEdit from "./components/chargingTypeEdit.vue";
// import compDetail from "./components/chargingTypeDetail.vue";
import costTypeSelect from "./components/costTypeSelect.vue";
import request from "@/utils/request";


export default {
  name: "ChargingTypeList",
  components: {
    compAdd,
    compEdit,
    // compDetail,
    costTypeSelect
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      cascadeData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      partyGroup:[],

      listQuery: {
        shipmentName: "",
        costType: "",
        chargingType: "",
        price: "",
        chargingMode: "",
        validityDate: "",
        endDate: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: []
    };
  },
  created() {
    this.getCascadeData();
  },
  methods: {
    //获取机构信息
    getPartyGroup() {
      request({
        url: '/ntocc-basic-api/partyGroup/getPartyGroup',
        method: 'get'
      }).then(response => {
        this.partyGroup = response.data
      }).then(response => {
        this.findList()
      })
    },

    // 选择托盘状态
    selectCostType(value) {
      this.listQuery.chargingType = value;
    },
    // 有效期格式化
    showCostType({ row }) {
      return row.startDate + " 至 " + row.endDate;
    }, // 有效期格式化
    termOfValidityFormatter({ row }) {
      return row.startDate + " 至 " + row.endDate;
    },

    // 获取字典数据
    getCascadeData() {
      request({
        url: "/ntocc-basic-api/costType/cascadeData",
        method: "get"
      })
        .then(response => {
          this.cascadeData = response.data;

          this.$refs.costType.initData(this.cascadeData, "queryCostType");
        })
        .then(response => {
          this.findList();
        });
    },
    // 翻译类型
    handleChange(value) {},
    formatterChargingMode({ cellValue }) {
      if (cellValue == "1") {
        return "吨";
      }
    },
    findList() {
      request({
        url: "/ntocc-basic-api/chargingType",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
      });
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs.costType.initData(
        this.cascadeData,
        "queryCostType"
      );
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.$refs.costType.initData(
        this.cascadeData,
        "queryCostType"
      );
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/chargingType`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return  this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>

<style>
</style>
